import type { LanguageCode } from '../i18n/languages';

/** Keep an explicit page update when it is newer than the translation release. */
export function latestModifiedDate(...dates: Array<string | undefined>): string | undefined {
  return dates.filter((date): date is string => Boolean(date && Number.isFinite(Date.parse(date))))
    .reduce<string | undefined>((latest, date) => !latest || Date.parse(date) > Date.parse(latest) ? date : latest, undefined);
}

// Social metadata requires language_TERRITORY. Search hreflang stays language-wide.
export const OPEN_GRAPH_LOCALES: Record<LanguageCode, string> = {
  en: 'en_US', es: 'es_ES', ru: 'ru_RU', fr: 'fr_FR', de: 'de_DE', it: 'it_IT',
  pt: 'pt_BR', nl: 'nl_NL', pl: 'pl_PL', zh: 'zh_CN', ja: 'ja_JP', ko: 'ko_KR',
  tr: 'tr_TR', ar: 'ar_SA', hi: 'hi_IN', uk: 'uk_UA', vi: 'vi_VN', bg: 'bg_BG',
  cs: 'cs_CZ', fi: 'fi_FI', el: 'el_GR', id: 'id_ID', ro: 'ro_RO', th: 'th_TH',
};
